import {HospitalInformation} from "./hospital-information";
import {isNonRequiredTextOfMaxLength} from "../../validations";
import {FormValidator} from "../../../tools/form/form-validator";

export class HospitalInformationValidator extends FormValidator<HospitalInformation> {

  constructor(hospitalInformation: HospitalInformation) {
    super(new Map<keyof HospitalInformation, () => boolean>()
      .set("publicName", () => isNonRequiredTextOfMaxLength(100, hospitalInformation.publicName))
      .set("operatorAppointmentDescription", () => isNonRequiredTextOfMaxLength(1000, hospitalInformation.operatorAppointmentDescription))
      .set("address", () => isNonRequiredTextOfMaxLength(1000, hospitalInformation.address))
      .set("postalCode", () => isNonRequiredTextOfMaxLength(100, hospitalInformation.postalCode))
      .set("city", () => isNonRequiredTextOfMaxLength(100, hospitalInformation.city)));
  }
}
